import React from 'react';
import { IconProps } from '.';

const SvgColoredEyes = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#E2E5E6'
        fillRule='evenodd'
        d='M11.187 12c0 4.89-2.374 8.854-5.302 8.854C2.957 20.854.583 16.89.583 12c0-4.89 2.374-8.854 5.302-8.854 2.928 0 5.302 3.964 5.302 8.854Zm12.27 0c0 4.89-2.373 8.854-5.302 8.854-2.928 0-5.302-3.964-5.302-8.854 0-4.89 2.374-8.854 5.303-8.854 2.928 0 5.302 3.964 5.302 8.854Z'
        clipRule='evenodd'
      />
      <path fill={color} d='M4.397 15.306a3.307 3.307 0 1 0 0-6.613 3.307 3.307 0 0 0 0 6.613Z' />
      <path fill='#fff' d='M5.274 11.246a.95.95 0 1 0 0-1.9.95.95 0 0 0 0 1.9Z' />
      <path fill={color} d='M16.666 15.306a3.307 3.307 0 1 0 0-6.613 3.307 3.307 0 0 0 0 6.613Z' />
      <path fill='#fff' d='M17.544 11.246a.95.95 0 1 0 0-1.901.95.95 0 0 0 0 1.901Z' />
    </svg>
  );
};

export default SvgColoredEyes;
